export default "__VITE_ASSET__b56c90bb__"